import React from 'react'
import styles from './ImageCheckbox.module.css'
import { ImageItems } from './types'

const IMAGES: ImageItems = {
    checked: { src: '/entry_form_slide_app/steps/step5/checked.png', alt: '選択済み' },
    unchecked: { src: '/entry_form_slide_app/steps/step5/unchecked.png', alt: '未選択' },
}

export const ImageCheckbox = ({
                                    checked,
                                    onChange,
                                    name,
                                    altPurpose,
                                    dataClickLabel
                                }: {
    checked: boolean
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    name?: string
    altPurpose: string
    dataClickLabel: string
}) => {
    const altText = `${altPurpose}: ${checked ? IMAGES.checked.alt : IMAGES.unchecked.alt}`
    return (
        <label
            className={styles.checkboxLabel}
        >
            <input
                type='checkbox'
                checked={checked}
                onChange={onChange}
                name={name}
                style={{ display: 'none' }}
                data-click-label={dataClickLabel}
            />
            <img
                src={checked ? IMAGES.checked.src : IMAGES.unchecked.src}
                alt={altText}
                className={styles.checkboxImage}
            />
        </label>
    )
}